import { api } from "./api_core";

export const yunyingApi = {
  // ==================== 管理员接口 ====================
  getAdminUsers: async () => {
    const response = await api.get("/admin/users");
    return response.data;
  },
  getAdminUserDetail: async (userId) => {
    const response = await api.get(`/admin/users/${userId}`);
    return response.data;
  },
  getAdminServices: async () => {
    const response = await api.get("/admin/services");
    return response.data;
  },
  createAdminService: async (data) => {
    const response = await api.post("/admin/services", data);
    return response.data;
  },
  updateAdminService: async (id, data) => {
    const response = await api.put(`/admin/services/${id}`, data);
    return response.data;
  },
  deleteAdminService: async (id) => {
    const response = await api.delete(`/admin/services/${id}`);
    return response.data;
  },

  // ==================== 权限管理接口 ====================
  getAdminPermissions: async () => {
    const response = await api.get("/admin/permissions");
    return response.data;
  },
  createAdminPermission: async (data) => {
    const response = await api.post("/admin/permissions", data);
    return response.data;
  },
  updateAdminPermission: async (id, data) => {
    const response = await api.put(`/admin/permissions/${id}`, data);
    return response.data;
  },
  deleteAdminPermission: async (id) => {
    const response = await api.delete(`/admin/permissions/${id}`);
    return response.data;
  },

  // ==================== 服务-权限配置接口 ====================
  getServicePermissions: async (serviceId) => {
    const response = await api.get(`/admin/services/${serviceId}/permissions`);
    return response.data;
  },
  updateServicePermissions: async (serviceId, permissionIds) => {
    const response = await api.post(`/admin/services/${serviceId}/permissions`, { permission_ids: permissionIds });
    return response.data;
  },

  // ==================== 数据统计接口 ====================
  getSubscriptionStats: async (params) => {
    const response = await api.get("/admin/stats/subscriptions", { params });
    return response.data;
  },

  // ==================== 占题类型管理接口 ====================
  getAdminZhantiTypes: async () => {
    const response = await api.get("/admin/zhanti_types");
    return response.data;
  },
  createAdminZhantiType: async (data) => {
    const response = await api.post("/admin/zhanti_types", data);
    return response.data;
  },
  updateAdminZhantiType: async (id, data) => {
    const response = await api.put(`/admin/zhanti_types/${id}`, data);
    return response.data;
  },
  deleteAdminZhantiType: async (id) => {
    const response = await api.delete(`/admin/zhanti_types/${id}`);
    return response.data;
  },
};